import ReactHelmet from "react-helmet";

import useOrg from "Hooks/useOrg";

const Helmet = ({description, title}) => {

	const {org} = useOrg();

	let titleVar = (org?.NameTrade || "HOPS");
	if (title) titleVar += ` - ${title}`;

	return (
		<ReactHelmet>
			<title>{titleVar}</title>
			{(description && <meta name="description" content={description} />)}
		</ReactHelmet>
	);

};

export default Helmet;
